/**
 * How many servings the app plans for when nothing else says otherwise.
 *
 * The catalog is authored at 3 servings, so this has to be 3. It was 2, and
 * every quantity in the app was therefore being scaled by 2/3 before it was
 * displayed: "1 1/6 tsp fresh rosemary", "2/3 red bell pepper",
 * "8 1/4 tbsp olive oil". None of those are rounding bugs — the arithmetic was
 * right, the multiplier was wrong. At the authored count the same lists come
 * out in whole units.
 *
 * Used for two related things, and deliberately the same number for both:
 *   - the servings a new schedule is built for (the builder's stepper start,
 *     and `target_servings` on POST /schedule/create — see
 *     `schemas.ScheduleCreate`, which carries the same default server-side)
 *   - the assumed authored size of a recipe whose own `servings` is null,
 *     which is the denominator of the display scale. Assuming 4 there
 *     re-introduced the same 3/4 multiplier for exactly those recipes.
 */
export const CATALOG_DEFAULT_SERVINGS = 3;

export default CATALOG_DEFAULT_SERVINGS;
